import React, { useState, useEffect } from 'react';
import SideBar from '../../Components/AdminDashboard/Admincommon/SideBar';
import Header from '../../Components/AdminDashboard/Admincommon/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../../src/pages/admin/admin_assets/css/sb-admin-2.min.css';
import '../../../src/pages/admin/admin_assets/css/common.css';
import '../../../src/pages/admin/admin_assets/css/responsive.css';
import '../../../src/pages/admin/admin_assets/css/Configure.css';
import HideText from '../../Components/AdminDashboard/Admincommon/HidePageText';
import Tags from '../../Components/AdminDashboard/Adminebook/Tags';



const TagsPage = () => 
{

    
    return (
        <div id="page-top">
        <div id="wrapper" className='admin_sidebar'>
          <SideBar />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content" style={{ backgroundColor: '#F5F7F8' }} className='category_table'>
              <Header />
              <Tags />

            </div>
          </div>
        </div>
        <HideText/>
      </div>
    );
};



export default TagsPage;